module.exports = __webpack_public_path__ + "static/media/point_towards.4e072dd4.png";